<template>
	<div style="width: 100%;">
		<el-form ref="fw_form" :model="form" :inline="false" :rules="rules" label-position="left" label-width="200px"
			style="width: 50%; margin-left: 0%;">
			<el-form-item label="硬件版本号" prop="hw_ver">
				<el-input-number v-model="form.hw_ver" :min="1" :max="65535" label="硬件版本号1-65535" :precision="0"></el-input-number>
			</el-form-item>

		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button @click="submit" type="primary">创建</el-button>
		</span>
	</div>
</template>

<script lang="js">
import { addHardware } from '@/api';

export default {
	data() {
		return {
			form: {
				hw_ver: 1,
				force: false
			},

			rules: {
				hw_ver: [{required: true, message: '硬件版本号1-65535'}]
			}
		};
	},
	methods: {
		submit() {
			var that = this;
			addHardware(this.form.hw_ver).then(res => {
				console.log('upload hardware resp: ', res);
				if (res.data.code === 200) {
					this.open2();
				} else {
					that.open4(res.data.msg + '[' + res.data.code + ']');
				}
			})
		},
		open2() {
			this.$message({
				message: '操作成功',
				type: 'success'
			});
		},
		open4(err) {
			this.$message.error('操作失败: ' + err);
		}
	}
}
</script>